function getFlairExtraContentText(filterName, value) {
    if (!value) {
        return '';
    }

    switch (filterName) {
        case 'privateGallery':
            return this.translate.home.hasAGallery;
        case 'videos':
            return this.translate.home.hasAVideos;
        case 'fskContent':
            return this.translate.home.hasFskContent;
        default:
            return '';
    }
}

function getFlairExtraContentTextMobile(extraContent) {
    const result = [];

    _.forEach(extraContent, (value, key) => {
        const text = this.getFlairExtraContentText(key, value);
        if (text) {
            result.push(text);
        }
    })

    return result.join(', ');
}

function removeExtraContentFlair(extraContent, subFilter) {
    delete extraContent[subFilter];

    return extraContent;
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        getFlairExtraContentText,
        removeExtraContentFlair,
        getFlairExtraContentTextMobile,
    },
    computed: {
        ...mapState([
            'translate',
        ]),
    },
}
